export default __webpack_public_path__ + "static/media/yuryu-12.8f9f64d3.svg";